module.exports = __webpack_public_path__ + "media/music/piano_1-0b3f929a.mp3";